import React from 'react';
import './NoCompanyAccess.css';

/**
 * Component displayed when user has no company access
 * Shows a message to contact admin or Revetall
 */
const NoCompanyAccess = ({ companyError }) => {
  return (
    <div className="no-access-container">
      <div className="no-access-content">
        <div className="no-access-icon">
          <img src="/revetall-icon.svg" alt="Revetall Logo" className="logo-icon" />
        </div>
        
        <h2>Ingen tilgang til selskap</h2>
        
        <div className="error-message">
          <p>{companyError || "Ingen selskapstilgang funnet. Kontakt din administrator eller Revetall direkte."}</p>
        </div>
        
        <div className="contact-info">
          <h3>Trenger du tilgang?</h3>
          <p>Vennligst kontakt:</p>
          <ul>
            <li><strong>Din bedriftsadministrator</strong> for å få tilgang til selskapsdata</li>
            <li><strong>Revetall support</strong> hvis du trenger teknisk hjelp</li>
          </ul>
        </div>
        
        <div className="help-actions">
          <a 
            href="mailto:post@revetall.ai" 
            className="contact-button"
          >
            Kontakt Revetall Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoCompanyAccess;
